// src/components/layout/Footer.jsx
import React from "react";
import { footerGridLinks, footerSeoLinks, paymentMethods, footerMeta } from "../../data/footerData";



const FacebookIcon = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>;
const InstagramIcon = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"/><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/></svg>;
const TwitterIcon = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z"/></svg>;
const MailIcon = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>;
const WhatsAppIcon = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="white" className="md:w-7 md:h-7"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51a12.8 12.8 0 0 0-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.82 9.82 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"/></svg>;
const ArrowRight = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="ml-2"><path d="M4 12h16M13 5l7 7-7 7"/></svg>;

const Footer = () => {
  return (
    <footer className="bg-[#fce954] text-black pt-8 pb-5 xs:pt-10 xs:pb-6 md:pt-16 md:pb-8 relative border-t border-black/10">
      <div className="max-w-[1400px] mx-auto px-4 xs:px-5 sm:px-6 md:px-12 lg:px-20">

        {/* TOP SECTION */}
        <div className="flex flex-col lg:flex-row gap-8 xs:gap-10 sm:gap-12 lg:gap-24 mb-8 xs:mb-10 sm:mb-16">

          {/* LEFT COLUMN */}
          <div className="w-full lg:w-[25%] flex flex-col items-center text-center lg:items-start lg:text-left">
            <div className="mb-5 xs:mb-6 sm:mb-8">
              <a href="/" className="inline-flex items-center gap-2 text-[#060606] text-3xl xs:text-4xl md:text-5xl font-bold tracking-wide" style={{ fontFamily: "'Dancing Script', cursive" }}>
               
                Aishcraft
              </a>
            </div>

            <h4 className="text-[10px] xs:text-[11px] font-bold tracking-widest uppercase mb-3 xs:mb-4 opacity-70">Connect With Us</h4>
            <div className="flex gap-4 mb-6 xs:mb-8 sm:mb-10">
           <a href="https://www.instagram.com/aishcrafts.co?igsh=ejdjdWw2N3Zkd2Vt" className="hover:opacity-60 active:scale-90 transition-all" aria-label="Visit our Instagram profile"><InstagramIcon /></a>
<a href="https://www.facebook.com/profile.php?id=61591698291802" className="hover:opacity-60 active:scale-90 transition-all" aria-label="Visit our Facebook page"><FacebookIcon /></a>
<a href="#" className="hover:opacity-60 active:scale-90 transition-all" aria-label="Visit our Twitter profile"><TwitterIcon /></a>
<a href="#" className="hover:opacity-60 active:scale-90 transition-all" aria-label="Email us"><MailIcon /></a>
            </div>

            <h4 className="text-[10px] xs:text-[11px] font-bold tracking-widest uppercase mb-3 xs:mb-4 opacity-70">Newsletter</h4>
            <h3 style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: "italic" }} className="text-[22px] xs:text-[26px] sm:text-[32px] md:text-[36px] font-medium leading-tight mb-2.5 xs:mb-3">
              Join our Newsletter
            </h3>
            <p className="text-[12.5px] xs:text-[13px] leading-relaxed mb-4 opacity-80 max-w-xs lg:max-w-none">
              Get the updates first. Signup to receive content that's tailored just for you.
            </p>
            <form className="w-full">
              <input type="email" placeholder="abcd@gmail.com" inputMode="email" className="w-full border border-black/20 rounded-sm px-4 py-2.5 text-[13px] outline-none focus:border-black mb-3 bg-white" />
              <button type="submit" className="w-full bg-black hover:bg-gray-800 active:scale-[0.98] text-white font-bold text-[13px] tracking-wide py-3 rounded-sm transition-all">
                Sign Me Up!
              </button>
            </form>
          </div>

          {/* RIGHT COLUMN */}
          <div className="w-full lg:w-[75%] flex flex-col">
            <div className="flex flex-col md:flex-row justify-between items-center border-b border-black/10 pb-5 xs:pb-6 sm:pb-8 mb-6 xs:mb-8 sm:mb-10 gap-3 xs:gap-4 text-center md:text-left">
              <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: "italic" }} className="text-[22px] xs:text-[26px] sm:text-[34px] md:text-[42px] font-medium leading-tight w-full md:w-auto">
                Contact Us for Exclusive Bulk Orders
              </h2>
              <a href={`tel:${footerMeta.phone}`} className="w-full md:w-auto bg-black hover:bg-gray-800 active:scale-[0.98] text-white px-6 xs:px-8 py-2.5 xs:py-3 rounded-sm text-[12.5px] xs:text-[13px] font-bold tracking-wide flex items-center justify-center transition-all">
                Call Us <ArrowRight />
              </a>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-x-3 xs:gap-x-4 gap-y-6 xs:gap-y-8 sm:gap-8">
              {footerGridLinks.map((column, index) => (
                <div key={index}>
                  <h4 className="text-[10px] xs:text-[11px] font-bold tracking-[0.13em] uppercase mb-3.5 xs:mb-5">{column.title}</h4>
                  <ul className="space-y-2.5 xs:space-y-3 text-[12.5px] xs:text-[13px] opacity-80">
                    {column.links.map((link, idx) => (
                      <li key={idx}><a href={link.url} className="hover:underline underline-offset-4">{link.name}</a></li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="w-full h-px bg-black/10 mb-6 xs:mb-8 sm:mb-10"></div>

        {/* BOTTOM SEO SECTION */}
        <div className="flex flex-col gap-5 xs:gap-6 mb-8 xs:mb-10 sm:mb-12">
          {footerSeoLinks.map((section, index) => (
            <div key={index}>
              <h4 style={{ fontFamily: "'Cormorant Garamond', serif", fontStyle: "italic" }} className="text-[18px] xs:text-[20px] sm:text-[24px] font-medium mb-2">{section.title}</h4>
              <p className="text-[11px] xs:text-[12px] opacity-80 leading-relaxed">
                {section.links.map((link, idx) => (
                  <React.Fragment key={idx}>
                    <a href={link.url} className="hover:underline">{link.name}</a>
                    {idx !== section.links.length - 1 && <span className="mx-1.5 opacity-50">|</span>}
                  </React.Fragment>
                ))}
              </p>
            </div>
          ))}
        </div>

        {/* POLICY LINKS SECTION */}
        <div className="flex flex-wrap justify-center gap-3 xs:gap-4 sm:gap-6 mb-6 xs:mb-8 text-[10px] xs:text-[11px] sm:text-[12px] font-semibold uppercase tracking-widest text-black/80">
          <a href="/privacy-policy" className="hover:text-black transition-colors">Privacy Policy</a>
          <a href="/terms-of-service" className="hover:text-black transition-colors">Terms of Service</a>
          <a href="/refund-policy" className="hover:text-black transition-colors">Refund Policy</a>
        </div>

        {/* PAYMENT + META */}
       
      </div>

      {/* WHATSAPP WIDGET */}
    <a href={footerMeta.whatsappLink} target="_blank" rel="noopener noreferrer" className="fixed bottom-3.5 right-3.5 xs:bottom-4 xs:right-4 sm:bottom-6 sm:right-6 z-50 flex items-center gap-3 group" aria-label="Chat with us on WhatsApp">
        <div className="hidden sm:block bg-white px-3 py-1.5 rounded-full shadow-md text-[12px] font-medium opacity-0 translate-x-4 group-hover:opacity-100 group-hover:translate-x-0 transition-all">
          Hey, Let's Chat
        </div>
        <div className="bg-[#25D366] w-11 h-11 xs:w-12 xs:h-12 sm:w-14 sm:h-14 rounded-full flex items-center justify-center shadow-lg hover:scale-105 active:scale-95 transition-transform">
          <WhatsAppIcon />
        </div>
      </a>
    </footer>
  );
};

export default Footer;